module.exports = __webpack_public_path__ + "img/logo-white.2702bd2c.svg";